// extracted by mini-css-extract-plugin
export default {"imageWrapper":"bQ-z","hovered":"cQ-z","hoverImage":"dQ-z","mainImage":"eQ-z","imageNoBackground":"fQ-z","fullSizeImage":"gQ-z"};